<template>
  <div>
    <h3 class="text-center">Stages</h3>
    <hr />
    <br/>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="stagename">Stage Name</label>
      <input type="text" v-model="stagename" class="form-control" id="stagename" placeholder="Name of the stage" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="input-type">Input Type</label>
      <select id="input-type" v-model="inputType" class="form-control" v-on:change="setOptions">
        <option value="">--No input--</option>
        <option value="Number">Number</option>
        <option value="Boolean">Boolean</option>
        <option value="Text">Text</option>
      </select>
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="options">Options</label>
      <input type="text" v-model="options" :disabled="inputType == 'Boolean'" class="form-control" id="options" placeholder="Text input mapping, comma separated" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="next-stages">Next Stage(s)</label>
      <input type="text" v-model="nextStages" class="form-control" id="next-stages" placeholder="Next stage(s); comma separated" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label>Failed</label>
        <input type="text" v-model="failed" class="form-control" placeholder="Next stage if there's an input failure" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label>Next App (if any)</label>
        <select id="input-type" v-model="nextApp" class="form-control" v-on:change="setOptions">
        <option value="">--Select app--</option>
        <option v-for="(each, key) in allApps" :key="key" :value="each.value">{{each.name}}</option>
      </select>
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label>Skip If</label>
      <div class="two-fields">
        <select v-on:change="getPropertyKeys('skip', skip.type)" v-model="skip.type" class="form-control">
          <option value="">No Property</option>
          <option value="account">Account</option>
          <option value="session">Session</option>
        </select>
        <select v-model="skip.key" class="form-control">
          <option value="">No Key</option>
          <option v-for="(each, index) in propertyKeys.skip" :key="index" :value="each.value">{{each.name}}</option>
        </select>
      </div>
    </div>

    <div class="form-group col-xs-12 col-sm-6">
      <label>Notification</label>
      <input type="text" v-model="notification" class="form-control" placeholder="Notification to chatbot" />
    </div>

    <div v-show="isScreening">
      <br clear="all"/><br clear="all"/><br/>
      <h4 class="text-center">Methods Addition/Removal</h4>
      <div class="form-group col-xs-12 col-sm-3">
        <label>Option</label>
        <select v-model="methodOption" class="form-control">
          <option value="">--Select Option--</option>
          <option v-for="(each, index) of allOptions" :key="index">{{each}}</option>
        </select>
      </div>

      <div class="form-group col-xs-12 col-sm-4">
        <label>Action</label>
        <select v-model="methodTypeModification" class="form-control">
          <option value="">--Select Action--</option>
          <option value="add">Add Methods</option>
          <option value="remove">Remove Methods</option>
        </select>
      </div>

      <div class="form-group col-xs-12 col-sm-4">
        <label>Methods</label>
        <select multiple v-model="choosenMethods" class="form-control">
          <option v-for="(value, key) in allMethods" :key="key" :value="key">{{value.name + ' [' + value.altName + ']'}}</option>
        </select>
      </div>
      <div class="form-group col-xs-12 col-sm-1">
        <i class="fa fa-plus-circle add-property" v-on:click="addOrRemoveMethod" aria-hidden="true"></i>
      </div>
      <br clear="all"/><br clear="all"/><br/>
      <table class="table table-striped" v-show="showMethodsTable">
        <thead>
          <th>Option</th>
          <th>Action</th>
          <th>Methods</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="(value, eachOption) in methods" :key="eachOption">
            <td>{{eachOption}}</td>
            <td>{{value.type}}</td>
            <td>{{value.methods}}</td>
            <td><i class="fa fa-times-circle" v-on:click="deleteMethodOption(eachOption, methods)" aria-hidden="true"></i></td>
          </tr>
        </tbody>
      </table>
      <br clear="all"/><br clear="all"/><br/>
    </div>
    <br clear="all" />
    <h4 class="text-center">Text Message(s)</h4>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="english">English</label>
      <textarea rows="4" v-model="textMessage.eng" id="english" class="form-control" placeholder="English message" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="swahili">Swahili</label>
      <textarea rows="4" v-model="textMessage.swa" id="swahili" class="form-control" placeholder="Swahili message" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="property">Property</label>
      <div class="two-fields">
        <select v-model="property.type" v-on:change="getPropertyKeys('text', property.type)" id="property" class="form-control">
          <option value="">No Property</option>
          <option value="account">Account</option>
          <option value="session">Session</option>
        </select>
        <select v-model="property.key" id="property-key" class="form-control">
          <option value="">No Key</option>
          <option v-for="(each, index) in propertyKeys.text" :key="index" :value="each.value">{{each.name}}</option>
        </select>
        <i class="fa fa-plus-circle add-property" v-on:click="addProperty" aria-hidden="true"></i>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <table v-if="textMessage.properties.length" class="table table-striped">
        <thead>
          <th>Property</th>
          <th>Key</th>
          <th>Delete</th>
        </thead>
        <tbody>
          <tr v-for="(aProperty, index) in textMessage.properties" :key="index">
            <td>{{aProperty.type}}</td>
            <td>{{aProperty.key}}</td>
            <td><i class="fa fa-times-circle" v-on:click="deleteProperty(index)" aria-hidden="true"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
    <br clear="all" /><br />
    <div class="action-button">
      <input type="button" v-on:click="addMessage()" class="btn btn-primary" value="Add Message" />
    </div>
    <br />
    <div class="col-xs-12">
      <table v-if="allMessages.length" class="table table-striped">
        <thead>
          <th>English</th>
          <th>Swahili</th>
          <th>Properties</th>
          <th>Delete</th>
        </thead>
        <tbody>
          <tr v-for="(message, index) in allMessages" :key="index">
            <td>{{message.eng}}</td>
            <td>{{message.swa}}</td>
            <td>{{message.properties}}</td>
            <td><i class="fa fa-times-circle" v-on:click="deleteMessage(index)" aria-hidden="true"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action-button">
      <input type="button" class="btn btn-primary" :value="caption" v-on:click="addStage()" />
    </div>
  </div>
</template>

<script>
import MethodMap from './methods'
export default {
  name: 'app-new-stage',
  props: ['stageDetails', 'isScreening', 'allApps'],
  methods: {
    /**
     * @function addMessage
     * @description adds a new text message
     */
    addMessage () {
      this.allMessages.push(this.textMessage)
      this.textMessage = {
        eng: '',
        swa: '',
        properties: []
      }
    },
    getPropertyKeys (type, propertyType) {
      if (propertyType === 'account') {
        this.propertyKeys[type] = [
          { value: 'age', name: 'Age' },
          { value: 'name', name: 'Name' },
          { value: 'gender', name: 'Gender' },
          { value: 'language', name: 'Language' },
          { value: 'married', name: 'Married' }
        ]
      } else if (propertyType === 'session') {
        this.propertyKeys[type] = [
          { value: 'facilities.name', name: 'Facility Name' }
        ]
      } else {
        this.propertyKeys[type] = []
      }
    },
    addProperty () {
      this.textMessage.properties.push(this.property)
      this.property = {
        type: '',
        key: ''
      }
    },

    /**
     * @function deleteProperty
     * @description remove a message property
     * @param {number} index - array index of the property to delete
     */
    deleteProperty (index) {
      this.textMessage.properties.splice(index, 1)
    },

    /**
     * @function deleteMessage
     * @description remove a message
     * @param {number} index - array index of the message to delete
     */
    deleteMessage (index) {
      this.allMessages.splice(index, 1)
    },

    /**
     * @function addStage
     * @description add a new stage to the sms app
     */
    addStage () {
      if (this.editedStage !== this.stageName) {
        // the stagename is different, delete the previous stage
        this.$emit('remove', this.editedStage)
        this.editedStage = ''
      }
      const stage = {
        text: this.allMessages
      }
      if (this.inputType) {
        stage['validations'] = {
          type: this.inputType
        }
        stage['input'] = true
        stage['type'] = 'questions'
      }
      if (this.options) {
        stage['options'] = this.options.split(/,\s*/)
      }
      if (this.inputType === 'Boolean') {
        // then overwrite options and assign it to [true, false]
        stage['options'] = [true, false]
      }
      if (this.nextStages) {
        const stages = this.nextStages.split(/,\s*/)
        stage['next'] = stages.length > 1 ? stages : stages[0]
      }
      if (this.failed) {
        stage['failed'] = this.failed
      }
      if (this.showMethodsTable) {
        stage['methods'] = this.methods
      }
      if (this.nextApp) {
        stage['nextApp'] = this.nextApp
      }
      if (this.notification) {
        stage.notification = this.notification
      }
      this.$emit('addStage', stage, this.stagename)
      this.resetValues()
    },
    resetValues () {
      const fields = ['stagename', 'options', 'nextStages', 'inputType', 'failed', 'notification', 'nextApp']
      fields.forEach(each => {
        this[each] = ''
      })
      this.skip = { type: '', key: '' }
      this.property = { type: '', key: '' }
      this.allMessages = []
      this.methods = {}
    },

    /**
      @description used to add or rule out methods based on users' response
    */
    addOrRemoveMethod () {
      this.$set(this.methods, this.methodOption, {type: this.methodTypeModification, methods: this.choosenMethods})
    },

    /**
      @description remove a method option details
      @param {string} option -
    */
    deleteMethodOption (option, methods) {
      this.$delete(this.methods, option)
    },

    setOptions  () {
      this.options = (this.inputType === 'Boolean') ? 'true, false' : ''
    }
  },
  data () {
    return {
      editedStage: '',
      stagename: '',
      options: '',
      nextStages: '',
      inputType: '',
      failed: '',
      nextApp: '',
      notification: '',
      propertyKeys: {
        skip: [],
        text: []
      },
      skip: {
        type: '',
        key: ''
      },
      property: {
        type: '',
        key: ''
      },
      textMessage: {
        eng: '',
        swa: '',
        properties: []
      },
      allMessages: [],
      methods: {},
      methodOption: '',
      methodTypeModification: '',
      choosenMethods: []
    }
  },

  watch: {
    stageDetails: function (value) {
      if (value.stageName) {
        this.stagename = value.stageName
        this.options = value.options ? value.options.join(', ') : ''
        this.nextStages = Array.isArray(value.next) ? value.next.join(', ') : value.next
        this.inputType = value.validations ? value.validations.type : ''
        this.failed = value.failed
        this.skip = value.skip || { type: '', key: '' }
        this.allMessages = value.text
        this.methods = value.methods || {}
        this.nextApp = value.nextApp
        this.editedStage = value.stageName
        this.notification = value.notification
      }
    }
  },

  computed: {
    allOptions: function () {
      return this.options.split(/,\s*/)
    },
    showMethodsTable: function () {
      return Object.keys(this.methods).length
    },
    allMethods: function () {
      return MethodMap.getMap()
    },
    caption: function () {
      return this.editedStage ? 'Edit Stage' : 'Add Stage'
    }
  }
}
</script>



// WEBPACK FOOTER //
// stage.vue?f7cd8ca0